module.exports = __webpack_public_path__ + "static/img/user.f95f54d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/user/user.png
// module id = a4NC
// module chunks = 0